__turbopack_context__.v({
  "active": "Tabs-module-scss-module__ng8lca__active",
  "disabled": "Tabs-module-scss-module__ng8lca__disabled",
  "expand": "Tabs-module-scss-module__ng8lca__expand",
  "limitedSpace": "Tabs-module-scss-module__ng8lca__limitedSpace",
  "shortHeight": "Tabs-module-scss-module__ng8lca__shortHeight",
  "tab": "Tabs-module-scss-module__ng8lca__tab",
  "tabs": "Tabs-module-scss-module__ng8lca__tabs",
  "title": "Tabs-module-scss-module__ng8lca__title",
  "wrapperFullWidth": "Tabs-module-scss-module__ng8lca__wrapperFullWidth",
});
